import { createReducer, on, createFeatureSelector } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { resetHistoryInvitations, setHistoryInvitations } from '../actions/history-invitations.actions';
import { Invitation } from '../models/invitation.model';

export const initialState: Pagination<Invitation> = null;

const reducer = createReducer(initialState,
  on(setHistoryInvitations, (state, historyInvitations) => historyInvitations),
  on(resetHistoryInvitations, () => initialState),
);

export const fromHistoryInvitations = {
  selectHistoryInvitationsState: createFeatureSelector<Pagination<Invitation>>('historyInvitations'),
};

export function historyInvitationsReducer(state, action) {
  return reducer(state, action);
}
